import React from "react";
//#region types
import { AuthEnums } from "models/enums";
import { SelfInvoiceMoreActionProps } from "models/propTypes/selfInvoicePropTypes";
import { MoreActionMenuItemType } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import { MoreActions } from "components/common";
import useSelfInvoiceSnoozeAction from "./useSnoozeAction";
import useCreateCustomerInvoiceAction from "./useCreateCustomerInvoiceAction";
//#endregion
import { CompanyService } from "services";

const SelfInvoiceMoreActions: React.FC<SelfInvoiceMoreActionProps> = (props) => {
  const { id, markAsDoneHandler, disableSuccessMessages } = props;

  const snoozeAction = useSelfInvoiceSnoozeAction(id, markAsDoneHandler ?? (() => {}));

  const createCustomerInvoiceAction = useCreateCustomerInvoiceAction(id);

  const getMenuItems = (): MoreActionMenuItemType[] => {
    const actions: MoreActionMenuItemType[] = [];
    if (!CompanyService.hasRelation(AuthEnums.PersonCompanyRelationType.Auditor)) {
      actions.push(snoozeAction);
      actions.push(createCustomerInvoiceAction);
    }
    return actions;
  };

  return <MoreActions menuItems={getMenuItems()} disableSuccessMessages={disableSuccessMessages} />;
};

export default SelfInvoiceMoreActions;
